"use client";

import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import { Button } from "@faire/web/slate/Button";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { Suspense, useState } from "react";

import { LazyStoryModal } from "@faire/retailer/views/brand/StoryModal";

type Props = {
  brand: IBrandViewV2Response.ILeanBrand;
  brandAboutSubheader: string | null;
};

export const StoryModalButton: React.FC<Props> = ({
  brand,
  brandAboutSubheader,
}) => {
  const [isStoryModalOpen, setIsStoryModalOpen] = useState(false);

  const openStoryModal = () => setIsStoryModalOpen(true);
  const closeStoryModal = () => setIsStoryModalOpen(false);

  return (
    <>
      <Button variant="tertiary" onClick={openStoryModal}>
        <StrictLocalMsg
          defaultMessage="Read their story"
          description={{
            text: "Click this link to open the modal to read the brand story!",
            img: "https://cdn.faire.com/fastly/722da3733f912d8a8ac3d422d23d2d720ee5702a31dc1eaec2c1db2e1d55b757.png",
          }}
        />
      </Button>

      {isStoryModalOpen ? (
        <Suspense fallback={null}>
          <LazyStoryModal
            onClose={closeStoryModal}
            brand={brand}
            aboutSubheader={brandAboutSubheader}
          />
        </Suspense>
      ) : null}
    </>
  );
};
